import { ReactNode } from 'react';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { IconElementProp } from 'components/action-button/types';
import { primitive } from 'styles/constants/primitives';

export const CartEntryActionButton = ({
  disabled,
  accessibilityLabel,
  testID,
  icon,
  children,
  onPress,
}: {
  disabled?: boolean;
  accessibilityLabel: string;
  testID: string;
  icon?: IconElementProp;
  children?: ReactNode;
  onPress?: () => void;
}) => {
  return (
    <ActionButton
      variant={ActionButtonVariants.TEXT_ONLY}
      padding={0}
      margin={0}
      keepIconSize
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      onPress={onPress}
      leftIcon={icon}
      disabled={disabled}
      color={disabled ? primitive.$blackOpacity50 : primitive.bk.$bbqBrown}
    >
      {children}
    </ActionButton>
  );
};
